import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useProject = (projectId) => {
  const fetchContext = useContext(FetchContext);

  return useQuery(["project", projectId, "info"], async () => {
    const { data } = await fetchContext.authAxios.get(`/projects/${projectId}`);
    return data;
  });
};
